import { useCallback, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  setLoadingType,
  setErrorType,
  openHeaderBox,
  setPasswordScreen,
} from "../../../../components/dataflow/utils-module";
import { clearFilter } from "../../../search/dataflow/search-module";
import { loginRequest } from "../../../../services/authConfig";
import { loginWithBackend } from "../../dataflow/auth-thunk";

export function useLogin() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { instance, inProgress } = useMsal();
  const isLoading = useSelector((state) => state.utils.isLoading);

  useEffect(() => {
    dispatch(clearFilter());
    dispatch(setPasswordScreen("password-reset"));
    dispatch(setErrorType({ type: "" }));
    dispatch(
      openHeaderBox({
        type: "",
        isOpen: false,
      })
    );
  }, [dispatch]);

  const isAzureLoading = isLoading.type === "login";
  const isBackendLoading = isLoading.type === "login-backend";

  const onFinishAzure = useCallback(() => {
    if (inProgress !== "none") return;
    dispatch(setLoadingType({ type: "login" }));
    instance.loginRedirect(loginRequest);
  }, [dispatch, inProgress, instance]);

  const onFinishBackend = useCallback(
    ({ email, password }) => {
      dispatch(setLoadingType({ type: "login-backend" }));
      dispatch(loginWithBackend(email, password, history));
    },
    [dispatch, history]
  );

  const goToResetPassword = useCallback(() => {
    history.push("/reset-password");
  }, [history]);

  return {
    onFinishAzure,
    onFinishBackend,
    isAzureLoading,
    isBackendLoading,
    goToResetPassword,
  };
}
